var pt = pt || {};
pt.blocografico = pt.blocografico || {};
pt.blocografico.library = pt.blocografico.library || {};
pt.blocografico.library.modalMedia = pt.blocografico.library.modalMedia || {};

pt.blocografico.library.modalMedia = (function () {
  let savePlaybackState;
  let currentMedia;
  const mediaPlayer = document.getElementById("mediaPlayer");
  const mediaTitle = document.getElementById("mediaTitle");
  const mediaModal = document.getElementById("mediaModal");

  /**
   * Sets the savePlaybackState flag to the specified value.
   *
   * @param {boolean} value - The value to set the savePlaybackState flag to. Defaults to true.
   */
  function setSavePlaybackState(value = true) {
    savePlaybackState = value;
  }

  /**
   * Returns the savePlaybackState function.
   *
   * @return {function} The savePlaybackState function.
   */
  function getSavePlaybackState() {
    return savePlaybackState;
  }

  /**
   * Load an audio file and display it in the media player.
   *
   * @param {string} audioURL - The URL of the audio file to be loaded.
   */
  function loadAudio(audioURL) {
    mediaPlayer.innerHTML = `<audio controls autoplay><source src="${audioURL}" type="audio/mp3">Your browser does not support the audio element.</audio>`;
    currentMedia = mediaPlayer.querySelector("audio");

    if (getSavePlaybackState()) {
      const storedTime = getPlaybackTime(audioURL);
      if (storedTime) {
        currentMedia.currentTime = parseFloat(storedTime) - 2;
      }
    }

    mediaModal.style.display = "block";
  }

  /**
   * Loads a video into the media player.
   *
   * @param {string} videoURL - The URL of the video to load.
   */
  function loadVideo(videoURL) {
    mediaPlayer.innerHTML = `<iframe width="100%" height="100%" src="${videoURL}" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>`;
    currentMedia = mediaPlayer.querySelector("iframe");
    mediaModal.style.display = "block";
  }

  /**
   * Set the playback time in the local storage.
   *
   * @param {string} key - The key to store the playback time.
   * @param {any} value - The value of the playback time.
   */
  function setPlaybackTime(key, value) {
    localStorage.setItem(key, value);
  }

  /**
   * Retrieves the playback time associated with the given key from the local storage.
   *
   * @param {string} key - The key used to retrieve the playback time from the local storage.
   * @return {string | null} - The playback time associated with the given key, or null if the key is not found.
   */
  function getPlaybackTime(key) {
    return localStorage.getItem(key);
  }

  /**
   * Closes the modal and performs additional actions if the current media is an HTMLAudioElement and the playback state should be saved.
   *
   * @param {type} paramName - description of parameter
   * @return {type} description of return value
   */
  function closeModal() {
    if (currentMedia instanceof HTMLAudioElement && getSavePlaybackState()) {
      setPlaybackTime(currentMedia.currentSrc, currentMedia.currentTime);
    }
    mediaPlayer.innerHTML = "";
    mediaModal.style.display = "none";
  }

  /**
   * Initializes the functionality of the page.
   *
   * @param {boolean} savePlaybackState - Whether to save the playback state or not. Defaults to false.
   */
  function init(savePlaybackState = false) {
    const audioBtns = document.querySelectorAll(".audioBtn");
    const videoBtns = document.querySelectorAll(".videoBtn");
    const closeModalBtn = document.getElementById("closeModalBtn");

    setSavePlaybackState(savePlaybackState);

    audioBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        mediaTitle.innerHTML = btn.getAttribute("data-title");
        const audioURL = btn.getAttribute("data-url");
        loadAudio(audioURL);
      });
    });

    videoBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        mediaTitle.innerHTML = btn.getAttribute("data-title");
        const videoURL = btn.getAttribute("data-url");
        loadVideo(videoURL);
      });
    });

    closeModalBtn.addEventListener("click", closeModal);

    window.addEventListener("click", function (event) {
      if (event.target === mediaModal) {
        closeModal();
      }
    });
  }

  return {
    init,
  };
})();
